import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../core/services/auth/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  resetForm: any;
  response: any;
  resetResponse: any;
  isLoading = false;

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _fb: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this._authService.isLoggedIn.subscribe((_isLoggedIn: boolean) => {
      if (_isLoggedIn) {
        this._router.navigate(['/change-viewer']);
      }
    });
    this.createForm();
  }

  createForm() {
    this.resetForm = this._fb.group({
      'EmailId': [null, Validators.compose([
        Validators.required,
        Validators.email
      ])]
    });
  }


  // onSubmit(formData: FormGroup) {
  //   this.resetResponse = 'Resetting Password...';
  //   if (formData.valid) {
  //     this.isLoading = true;
  //     this._authService.doLogin(formData.value)
  //       .subscribe((data: UserProfile) => {
  //         this.isLoading = false;
  //         this.resetResponse = null;
  //         this._sessionService.createSession(data);
  //         this._authService.updateLoginStatus();
  //         this._router.navigate(['/change-viewer']);
  //         setTimeout(() => {
  //           this.response = '';
  //         }, 5000);
  //       }, (_error: HttpErrorResponse) => {
  //         this.isLoading = false;
  //         this.response = 'Wrong email or password';
  //         setTimeout(() => {
  //           this.response = '';
  //         }, 5000);
  //         Logger.log(this.constructor.name, _error.error);
  //       });
  //   }
  // }
}
